import {
  FAQ_HOW_DO_PAYMENTS_WORK,
  FAQ_HOW_GET_INVITED,
  FAQ_NEGOTIATE_RATES,
  FAQ_WHAT_IS_MILLET_BRAND,
  FAQ_WHAT_IS_MILLET_INFLUENCER,
} from '../../../constants/faqData';

const MARKETING_PLATFORM_ORDER = ['Whatnot', 'TikTok', 'Instagram'];

export const MARKETING_SUPPORTED_PLATFORMS = MARKETING_PLATFORM_ORDER.map((name) => ({
  id: name.toLowerCase(),
  name,
}));

export const MARKETING_HERO_SIGNED_IN = {
  brand: {
    headline: 'Find a creator',
  },
  influencer: {
    headline: 'Find a campaign',
  },
};

export const MARKETING_HERO_LOGGED_OUT = {
  headlineLine1: 'Build the next iconic brand',
  headlineLine2: 'with creators',
  subtitle:
    'Millet is a live shopping marketplace to find those creators.',
  suggestionsHeading: 'Explore what you can do with Millet',
  platformsStripLabel: 'Supports collaborations for',
};

export const MARKETING_EXPLORE = {
  guestCards: [
    {
      id: 'discover',
      title: 'Explore Influencers',
      description: 'Find creators by niche, rate, and platform.',
      to: '/marketplace/influencers',
      requiresAuth: false,
    },
    {
      id: 'creator-map',
      title: 'Influencer Map',
      description: 'See who is near your market.',
      to: '/creator-map',
      requiresAuth: false,
    },
    {
      id: 'explore-campaigns',
      title: 'Explore campaigns',
      description: 'Browse live campaigns that are hiring creators.',
      to: '/marketplace/campaigns',
      requiresAuth: false,
    },
    {
      id: 'start-brand',
      title: 'For brands',
      description: 'Create a free account to invite creators and collaborate.',
      to: '/signup?userType=brand',
      requiresAuth: false,
    },
    {
      id: 'join-creator',
      title: 'For creators',
      description: 'Join free to apply, get invited, and get paid.',
      to: '/signup?userType=influencer',
      requiresAuth: false,
    },
    {
      id: 'pricing',
      title: 'Pricing',
      description: 'See plans for inviting creators and running collaborations.',
      to: '/pricing',
      requiresAuth: false,
    },
  ],
  cards: [
    {
      id: 'discover',
      title: 'Find influencers',
      description: 'Find creators by niche, rate, and platform.',
      to: '/marketplace/influencers',
      requiresAuth: false,
    },
    {
      id: 'creator-map',
      title: 'Influencer Map',
      description: 'See who is near your market before you invite.',
      to: '/creator-map',
      requiresAuth: false,
    },
    {
      id: 'invite',
      title: 'Invite',
      description: 'Send an offer with rates and deliverables, then lock it in.',
      to: '/marketplace/influencers',
      requiresAuth: true,
      allowedUserTypes: ['brand'],
    },
    {
      id: 'collaborate',
      title: 'Collaborate',
      description: 'Run shipping, content, live dates, and pay in one place.',
      to: '/dashboard/collaboration-journey',
      requiresAuth: true,
      allowedUserTypes: ['brand'],
    },
    {
      id: 'campaigns',
      title: 'Campaigns',
      description: 'Open a campaign and turn one collaboration into the next.',
      to: '/dashboard/campaigns',
      requiresAuth: true,
      allowedUserTypes: ['brand'],
    },
    {
      id: 'pricing',
      title: 'Pricing',
      description: 'See plans for inviting creators and running collaborations.',
      to: '/pricing',
      requiresAuth: false,
    },
  ],
  influencerCards: [
    {
      id: 'browse-campaigns',
      title: 'Campaigns',
      description: 'Find open live shopping campaigns and brands hiring creators.',
      to: '/marketplace/campaigns',
      requiresAuth: true,
      allowedUserTypes: ['influencer'],
    },
    {
      id: 'invites',
      title: 'Invites',
      description: 'Review brand invites and respond when you are ready.',
      to: '/dashboard/analytics?view=invites',
      requiresAuth: true,
      allowedUserTypes: ['influencer'],
    },
    {
      id: 'collaborate',
      title: 'Collaborate',
      description: 'Track shipping, content, live dates, and pay in one hub.',
      to: '/dashboard/collaboration-journey',
      requiresAuth: true,
      allowedUserTypes: ['influencer'],
    },
    {
      id: 'applications',
      title: 'Applications',
      description: 'Track every campaign application and status update.',
      to: '/dashboard/analytics?view=applications',
      requiresAuth: true,
      allowedUserTypes: ['influencer'],
    },
  ],
};

export const MARKETING_FINAL_CTA_LOGGED_OUT = {
  heading: 'Collaborations made simple',
  primaryLabel: 'Browse creators',
  primaryTo: '/marketplace/influencers',
  secondaryLabel: 'Sign up',
  secondaryTo: '/signup?userType=brand',
};

export const MARKETING_FAQ_HEADING = 'FAQs';

export const MARKETING_FAQ_BRAND_INTRO = {
  question: 'How do I get started?',
  answer: 'Browse creators, send invites, and track everything from your dashboard.',
};

export const MARKETING_FAQ_ITEMS = [
  FAQ_WHAT_IS_MILLET_BRAND,
  {
    question: 'How do I find the right creators?',
    answer: 'Browse by category, platform, rate, and location—or use the Creator Map.',
  },
  {
    question: 'How do invites and rates work?',
    answer: 'Send an invite, agree on rates and deliverables, then lock it in.',
  },
  {
    question: 'How do I manage a collaboration on Millet?',
    answer: 'Track shipping, content, live dates, and pay in one dashboard.',
  },
  FAQ_HOW_DO_PAYMENTS_WORK,
];

export const MARKETING_FAQ_INFLUENCER_INTRO = {
  question: 'How do I get started on Millet?',
  answer: 'Browse open campaigns, apply, or wait for brands to invite you.',
};

export const MARKETING_FAQ_INFLUENCER_ITEMS = [
  FAQ_WHAT_IS_MILLET_INFLUENCER,
  {
    question: 'Does it cost anything to join?',
    answer: 'No. It is free for creators to join and collaborate. Brands pay you.',
  },
  FAQ_HOW_GET_INVITED,
  FAQ_NEGOTIATE_RATES,
  FAQ_HOW_DO_PAYMENTS_WORK,
];
